$('form.report').submit(function(e){

	/*prepare*/
	e.preventDefault();
	var form = $(this);
	var trigger = $(this).find('.submit');
	trigger.html(trigger.attr('sending'));
	$(this).find('.hint').remove();

	/*create form data*/
	var data = new FormData($(this)[0]);
	data.append('handle','report');
	data.append('receivers',trigger.attr('receivers'));
	data.append('chats',trigger.attr('chats'));

	/*post*/
	$.ajax({
		type: 'POST',
		url: './',
		data: data,
		async: true,
		cache: false,
		contentType: false,
		processData: false,
		success: function(reply){

			/*feedback*/
			if(($.trim(reply) === 'success')){
				trigger.hide();
				form.append('<span class="hint success">'+trigger.attr('success')+'</span>');
			}else{
				trigger.html(trigger.attr('default'));
				form.append('<span class="hint error">'+trigger.attr('error')+'</span>');
				console.log(reply);
			}

		}

	});

});
